import React from 'react';
import ServicePage from './ServicePage';
import { faServer } from '@fortawesome/free-solid-svg-icons';
import ServerMaintenacneimage from "../assets/server-maintenance.webp";
import styled from 'styled-components';

const MaintenanceCard = styled.div`
  flex: 0 0 43%;
  margin-bottom: 30px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  
  @media (max-width: 987px) {
    flex: 0 0 93%;
  }
  
  @media (max-width: 768px) {
    flex: 0 0 85%;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const ServerMaintenancePage = () => {
  const features = [
    'Proactive monitoring and issue prevention',
    'Regular security updates and patch management',
    'Performance optimization and tuning',
    'Backup and disaster recovery solutions',
    'Hardware health monitoring and maintenance',
    '24/7 technical support and rapid response'
  ];

  const additionalContent = (
    <div>
      <h3 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px', color: '#333', textAlign: 'center' }}>
        Our Maintenance Services Include
      </h3>
      <CardContainer>
        <MaintenanceCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Preventive Maintenance</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            Our proactive approach to server maintenance helps identify and address potential issues before they impact your business operations. We perform regular health checks, optimize system performance, and ensure all components are functioning at their best.
          </p>
        </MaintenanceCard>
        <MaintenanceCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Security Management</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            We implement comprehensive security measures to protect your servers from threats. This includes regular security audits, vulnerability assessments, patch management, and implementing best practices for server security.
          </p>
        </MaintenanceCard>
        <MaintenanceCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Performance Monitoring</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            Our advanced monitoring tools track server performance metrics in real-time, allowing us to identify bottlenecks and optimize resource allocation. We ensure your servers operate at peak efficiency, even during high-demand periods.
          </p>
        </MaintenanceCard>
        <MaintenanceCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Backup & Recovery</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            We implement robust backup solutions and disaster recovery plans to ensure business continuity. Our backup systems are regularly tested to guarantee data integrity and quick recovery in case of any system failures.
          </p>
        </MaintenanceCard>
        </CardContainer>
    </div>
  );

  return (
    <ServicePage
      icon={faServer}
      title="Server Maintenance"
      subtitle="Comprehensive server maintenance services to ensure optimal performance, security, and reliability for your business infrastructure."
      description={["At Zenitech Solutions, our Server Maintenance services are designed to keep your server infrastructure running at peak performance — day in and day out. We provide comprehensive, ongoing support and management, covering everything from routine maintenance and critical security updates to performance optimization and rapid troubleshooting.",

"Our expert team works proactively to identify and resolve potential issues before they affect your operations, ensuring maximum uptime, security, and efficiency. We don't just fix problems when they arise — we anticipate them, helping you stay one step ahead and avoid costly disruptions.",

"With Zenitech Solutions by your side, you can trust that your servers are monitored, maintained, and fine-tuned by professionals who are as committed to your success as you are. Let us handle your infrastructure, so you can focus on growing your business with confidence."]}
      features={features}
      imagePath={ServerMaintenacneimage}
      additionalContent={additionalContent}
      featuresDesciption="At Zenitech Solutions, we provide proactive server maintenance to ensure your infrastructure runs smoothly. Our expert team handles monitoring, updates, security, and optimization with precision, keeping your servers secure, fast, and always performing at their best. With our attention to detail and hands-on support, your servers are ready to drive your business forward."
      metaTitle="Server Maintenance Services"
      metaDescription="Our Server Maintenance services provide comprehensive support and management for your server infrastructure. We handle routine maintenance, security updates, performance optimization, and rapid troubleshooting to keep your servers running at peak efficiency."
    />
  );
};

export default ServerMaintenancePage;